var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FlowIndicator',{attrs:{"current-point":"2"}}),_c('Basket',{attrs:{"order-type":_vm.OrderTypes.DINE_IN}}),_c('Button',{on:{"click":_vm.handlePayment}},[_vm._v(_vm._s(_vm.$t('button.confirm')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }